import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { catchError, takeUntil, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@src/core/services';
import { EnterType } from '@src/app/modules/login/login.model';
import { BaseResizableComponent } from '@src/app/modules/base';
import { CaptchaService } from '@src/app/modules/captcha';
import { EnvService } from '@src/app/modules/env';
import { AppConfigService } from '@src/app/modules/app-config';
import { environment } from '@src/environments/environment';

import { RegistrationFormUI } from './types';
import { RegistrationService } from './services';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationComponent extends BaseResizableComponent {
  private readonly registrationService = inject(RegistrationService);
  private readonly alertService = inject(AlertService);
  private readonly env = inject(EnvService);
  private readonly configService = inject(AppConfigService);
  private readonly captchaService = inject(CaptchaService);
  private readonly translateService = inject(TranslateService);

  @Input() associationId?: string;

  @Output() saved = new EventEmitter<string>();

  data?: RegistrationFormUI;
  loading = false;
  openPolicy = false;
  registrationActive = true;

  newUserId?: string;

  /** Номер версии приложения */
  readonly APP_VERSION = environment.appVersion;

  readonly EnterType = EnterType;
  readonly configData = this.configService.data$.value;

  override ngOnInit(): void {
    super.ngOnInit();

    // TODO: перенести в CaptchaComponent
    this.captchaService.captchaValid$.pipe(takeUntil(this.destroyed$$)).subscribe(res => {
      this.loading = false;

      if (res) {
        this.sendRegistrationForm(this.data);
      } else {
        this.alertService.error(this.translateService.instant('components.enterByCode.alerts.errors.captchaInvalid'));
      }
    });

    this.captchaService.challengeVisible$.pipe(takeUntil(this.destroyed$$)).subscribe(res => {
      this.loading = res;
    });

    this.captchaService.captchaError$.pipe(takeUntil(this.destroyed$$)).subscribe(() => {
      this.loading = false;
    });
  }

  saveRegistrationForm(data: RegistrationFormUI): void {
    this.loading = true;
    this.data = data;

    if (!this.env.isCordova && !this.configData?.captchaDisabled && !environment.featureFlags?.captchaDisabled) {
      this.captchaService.initCaptcha();
    } else {
      this.sendRegistrationForm(data);
    }
  }

  private sendRegistrationForm(data?: RegistrationFormUI) {
    if (!data) {
      return;
    }

    this.registrationService
      .sendRegistrationForm(data)
      .pipe(
        takeUntil(this.destroyed$$),
        catchError(err => {
          this.alertService.error(err);
          this.loading = false;
          this.cdr.markForCheck();

          return throwError(() => err);
        }),
      )
      .subscribe(res => {
        this.newUserId = res.id;

        this.registrationActive = false;
        this.loading = false;
        this.cdr.markForCheck();
      });
  }
}
